import { render, staticRenderFns } from "./addPart.vue?vue&type=template&id=418c3cbd&scoped=true&"
import script from "./addPart.vue?vue&type=script&lang=js&"
export * from "./addPart.vue?vue&type=script&lang=js&"
import style0 from "./addPart.vue?vue&type=style&index=0&id=418c3cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c3cbd",
  null
  
)

export default component.exports